import React from 'react';
import { ArrowRight } from 'lucide-react';
import Button from '../../common/Button';
import ErrorMessage from '../../common/ErrorMessage';

interface EmailFormProps {
  email: string;
  isLoading: boolean;
  error: string | null;
  validationError: string | null;
  onEmailChange: (email: string) => void;
  onSubmit: () => void;
}

const EmailForm: React.FC<EmailFormProps> = ({ 
  email, 
  isLoading, 
  error, 
  validationError,
  onEmailChange, 
  onSubmit 
}) => {
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSubmit();
    }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <input
            type="email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter your email address"
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors ${
              validationError ? 'border-red-300 bg-red-50' : 'border-gray-300'
            }`}
            aria-label="Email address"
          />
          {/* Show validation error directly under the input */}
          {validationError && (
            <p className="text-red-500 text-sm mt-1">{validationError}</p>
          )}
        </div>
        <Button 
          onClick={onSubmit}
          disabled={isLoading || !email}
          className="whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Subscribe to updates"
        >
          {isLoading ? 'Signing up...' : 'Get Updates'}
          {!isLoading && <ArrowRight className="w-4 h-4 ml-2" />}
        </Button>
      </div>
      
      {/* General errors still show with ErrorMessage component */}
      {error && <ErrorMessage error={error} />}
      
      <p className="text-sm text-gray-500 mt-3 text-center">
        No spam, unsubscribe at any time.
      </p>
    </div>
  );
};

export default EmailForm;